import { CONST } from '../../const/const'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IRecipientInterface } from './recipients.interface'

// Constants
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export class RecipientModel extends ModelBaseModel<IRecipientInterface> {
  // Properties
  public v: IRecipientInterface['v']
  public id: IRecipientInterface['id']
  public userId: IRecipientInterface['userId']
  public registrationDate: IRecipientInterface['registrationDate']
  public recipientProfilePicture: IRecipientInterface['recipientProfilePicture']
  public recipientId: IRecipientInterface['recipientId']
  public recipientName: IRecipientInterface['recipientName']
  public registrationDocId: IRecipientInterface['registrationDocId']
  public userName: IRecipientInterface['userName']
  public eventId: IRecipientInterface['eventId']
  public refundStatus: IRecipientInterface['refundStatus']
  public eventName: IRecipientInterface['eventName']
  public amountRefunded: IRecipientInterface['amountRefunded']
  public amountScratched: IRecipientInterface['amountScratched']
  public amountPaid: IRecipientInterface['amountPaid']
  public amountTotal: IRecipientInterface['amountTotal']
  public comments: IRecipientInterface['comments']
  public created: IRecipientInterface['created']
  public modified: IRecipientInterface['modified']

  public constructor(obj?: IRecipientInterface) {
    super()

    this.id = obj?.id ?? COLLECTIONS.RECIPIENT.FIELDS.ID.VALUES.DEFAULT
    this.v = this.v ?? COLLECTIONS.RECIPIENT.FIELDS.VERSION.VALUES.DEFAULT
    this.userId = obj?.userId ?? COLLECTIONS.RECIPIENT.FIELDS.USER_ID.VALUES.DEFAULT
    this.eventId = obj?.eventId ?? COLLECTIONS.RECIPIENT.FIELDS.EVENT_ID.VALUES.DEFAULT
    this.recipientId = obj?.recipientId ?? COLLECTIONS.RECIPIENT.FIELDS.RECIPIENT_ID.VALUES.DEFAULT
    this.comments = obj?.comments ?? COLLECTIONS.RECIPIENT.FIELDS.COMMENTS.VALUES.DEFAULT
    this.registrationDate =
      obj?.registrationDate ?? COLLECTIONS.RECIPIENT.FIELDS.REGISTRATION_DATE.VALUES.DEFAULT
    this.registrationDocId =
      obj?.registrationDocId ?? COLLECTIONS.RECIPIENT.FIELDS.REGISTRATION_DOC_ID.VALUES.DEFAULT
    this.recipientProfilePicture =
      obj?.recipientProfilePicture ??
      COLLECTIONS.RECIPIENT.FIELDS.RECIPIENT_PROFILE_PICTURE.VALUES.DEFAULT
    this.recipientName =
      obj?.recipientName ?? COLLECTIONS.RECIPIENT.FIELDS.RECIPIENT_NAME.VALUES.DEFAULT
    this.refundStatus =
      obj?.refundStatus ?? COLLECTIONS.RECIPIENT.FIELDS.REFUND_STATUS.VALUES.DEFAULT
    this.userName = obj?.userName ?? COLLECTIONS.RECIPIENT.FIELDS.USER_NAME.VALUES.DEFAULT
    this.eventName = obj?.eventName ?? COLLECTIONS.RECIPIENT.FIELDS.EVENT_NAME.VALUES.DEFAULT
    this.amountRefunded =
      obj?.amountRefunded ?? COLLECTIONS.RECIPIENT.FIELDS.AMOUNT_REFUNDED.VALUES.DEFAULT
    this.amountScratched =
      obj?.amountScratched ?? COLLECTIONS.RECIPIENT.FIELDS.AMOUNT_SCRATCHED.VALUES.DEFAULT
    this.amountPaid = obj?.amountPaid ?? COLLECTIONS.RECIPIENT.FIELDS.AMOUNT_PAID.VALUES.DEFAULT
    this.amountTotal = obj?.amountTotal ?? COLLECTIONS.RECIPIENT.FIELDS.AMOUNT_TOTAL.VALUES.DEFAULT

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified,
    })
  }
  static fromFirestoreDoc(doc: any) {
    return new RecipientModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
